export const systemProps = [
  'margin',
  'm',
  'marginTop',
  'mt',
  'marginRight',
  'mr',
  'marginBottom',
  'mb',
  'marginLeft',
  'ml',
  'mx',
  'my',
  'padding',
  'p',
  'paddingTop',
  'pt',
  'paddingRight',
  'pr',
  'paddingBottom',
  'pb',
  'paddingLeft',
  'pl',
  'px',
  'py',
  'display',
  'width',
  'height',
  'maxWidth',
  'maxHeight',
  'minWidth',
  'minHeight',
  'size',
  'verticalAlign',
  'fontFamily',
  'fontSize',
  'lineHeight',
  'fontWeight',
  'textAlign',
  'letterSpacing',
  'color',
  'textTransform',
  'alignItems',
  'alignContent',
  'justifyContent',
  'justifyItems',
  'flexWrap',
  'flexBasis',
  'flexDirection',
  'flex',
  'justifySelf',
  'alignSelf',
  'order',
  'gridGap',
  'gridColumnGap',
  'gridRowGap',
  'gridColumn',
  'gridRow',
  'gridAutoFlow',
  'gridAutoColumns',
  'gridAutoRows',
  'gridTemplateColumns',
  'gridTemplateRows',
  'gridTemplateAreas',
  'gridArea',
  'background',
  'backgroundColor',
  'backgroundImage',
  'backgroundSize',
  'backgroundPosition',
  'backgroundRepeat',
  'position',
  'zIndex',
  'top',
  'right',
  'bottom',
  'left',
  'border',
  'borderTop',
  'borderTopColor',
  'borderRight',
  'borderRightColor',
  'borderBottom',
  'borderBottomColor',
  'borderLeft',
  'borderLeftColor',
  'borderColor',
  'borderWidth',
  'borderStyle',
  'borderRadius',
  'boxShadow',
  'textShadow',
  'opacity',
  'overflow',
];
